/// <amd-module name="SuiteCommerce.Blog.Common"/>
define("SuiteCommerce.Blog.Common", ["require", "exports", "underscore", "SuiteCommerce.Blog.BlogHome.Configuration", "Utils", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, _, BlogHome_Configuration_1, Utils_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.resizeImage = exports.sanitizeString = exports.DefaultTaxonomies = exports.AvailableTaxonomies = exports.BLOG_URL_BASE = void 0;
    exports.BLOG_URL_BASE = '/blog';
    var AvailableTaxonomies;
    (function (AvailableTaxonomies) {
        AvailableTaxonomies["category"] = "category";
        AvailableTaxonomies["term"] = "term";
        AvailableTaxonomies["tag"] = "tag";
        AvailableTaxonomies["author"] = "author";
    })(AvailableTaxonomies = exports.AvailableTaxonomies || (exports.AvailableTaxonomies = {}));
    var DefaultTaxonomies = /** @class */ (function () {
        function DefaultTaxonomies() {
        }
        Object.defineProperty(DefaultTaxonomies, "all", {
            get: function () {
                return {
                    name: BlogHome_Configuration_1.BlogHomeConfiguration.allArticlesTaxonomyName,
                    urlComponent: 'all',
                };
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DefaultTaxonomies, "featured", {
            get: function () {
                return {
                    defaultAlias: 'featured',
                };
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DefaultTaxonomies, "featuredInCategory", {
            get: function () {
                return {
                    defaultAlias: 'featured-in-category',
                };
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DefaultTaxonomies, "search", {
            get: function () {
                return {
                    defaultAlias: 'no-search-results',
                };
            },
            enumerable: false,
            configurable: true
        });
        return DefaultTaxonomies;
    }());
    exports.DefaultTaxonomies = DefaultTaxonomies;
    function sanitizeString(text) {
        return text ? text.replace(/[!\[\]$%^&*(){}|<>?+\/\\]/g, '') : '';
    }
    exports.sanitizeString = sanitizeString;
    function resizeImage(url, size) {
        var urlToUse = url ||
            Utils_1.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', Configuration_1.Configuration.get('imageNotAvailable'));
        var sizeToUse = Configuration_1.Configuration.get("imageSizeMapping." + size) || size;
        var resize = _.first(_.where(Configuration_1.Configuration.get('siteSettings.imagesizes') || [], {
            name: sizeToUse,
        }));
        if (resize) {
            return urlToUse + (~urlToUse.indexOf('?') ? '&' : '?') + resize.urlsuffix;
        }
        return urlToUse;
    }
    exports.resizeImage = resizeImage;
});
